var _path, _path2, _path3, _rect, _rect2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiffIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 113,
    viewBox: "0 0 103 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C12 2.23858 14.2386 0 17 0H72.5L103 32.5V108C103 110.761 100.761 113 98 113H17C14.2386 113 12 110.761 12 108V5Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103 32.5V62.5L73.2872 32.5L103 32.5Z",
    fill: "#CAD1D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 32.5V0L103 32.5H72.5Z",
    fill: "#3B478F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 93,
    width: 64,
    height: 11,
    fill: "#CAD1D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 56,
    width: 76,
    height: 41,
    rx: 2,
    fill: "#3B478F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9445 71.4262V69.4H25.0178V71.4262H20.1504V85H17.8043V71.4262H12.9445ZM30.0394 69.4V85H27.6857V69.4H30.0394ZM33.4671 85V69.4H43.141V71.4262H35.8209V76.1793H42.4478V78.1979H35.8209V85H33.4671ZM46.0355 85V69.4H55.7093V71.4262H48.3892V76.1793H55.0162V78.1979H48.3892V85H46.0355Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiffIcon);
export default __webpack_public_path__ + "static/media/tiff-icon.2d8a5fce37673572b79e9e4067832688.svg";
export { ForwardRef as ReactComponent };